// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__UXI46","log":"ModalInventoryLogs_log__wFvOJ","date":"ModalInventoryLogs_date__1dDqU","userName":"ModalInventoryLogs_userName__ePJP3"};